import { useAuth } from 'context/AuthContext';
import { findLateralMenagers } from 'services/profile.service';

import ModalDeBusca, { PessoaEncontrada } from './ModalDeBusca';
import { GestorEncontrado, pessoaDoGestor } from './pessoa-da-busca';

/**
 * Gestor escolhido: `id` é o player_fields que o `equipe_gestor` recebe; `chave` é a matrícula que as filas de
 * apreciação leem de `manager_lateralidade`.
 */
export interface GestorLateral {
  id: string;
  chave: string;
  nome: string;
  nomeGuerra: string;
}

export interface ModalEquipeLateralProps {
  isOpen: boolean;
  onFechar: () => void;
  onEscolher: (gestor: GestorLateral) => void;
  /** Textos de quem abre: a Minha Equipe vê a equipe; a Home vai direto à apreciação. */
  titulo?: string;
  texto?: string;
  rotuloDoConfirmar?: string;
}

/** Seletor de um gestor lateral do prefixo (lateralidade ou substituição), na Minha Equipe e na Home. */
export default function ModalEquipeLateral({
  isOpen,
  onFechar,
  onEscolher,
  titulo = 'Visualizar equipe lateral',
  texto = 'Escolha um gestor do seu prefixo para ver a equipe que você aprecia em lateralidade ou substituição.',
  rotuloDoConfirmar = 'Ver equipe',
}: ModalEquipeLateralProps) {
  const { user } = useAuth();

  async function buscar(termo: string) {
    if (!user?._id) return [];
    const encontrados: GestorEncontrado[] = await findLateralMenagers(user?._id, termo);
    return (Array.isArray(encontrados) ? encontrados : []).filter(gestor => !!gestor.extra?.id).map(pessoaDoGestor);
  }

  function escolher({ dados }: PessoaEncontrada<GestorEncontrado>) {
    const nome = dados.name ?? dados._id;
    onEscolher({ id: dados.extra?.id as string, chave: dados._id, nome, nomeGuerra: dados.extra?.nome_guerra ?? nome });
  }

  return (
    <ModalDeBusca
      isOpen={isOpen}
      titulo={titulo}
      texto={texto}
      rotuloDoCampo="Gestor"
      placeholder="Digite o nome ou a chave do gestor"
      rotuloDoConfirmar={rotuloDoConfirmar}
      buscar={buscar}
      confirmar={escolher}
      onFechar={onFechar}
    />
  );
}
